import { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../api/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    if (!token) {
      setStatus('error');
      setMessage('No verification token found in this link.');
      return;
    }

    (async () => {
      try {
        await authAPI.verifyEmail(token);
        setStatus('success');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may have expired.');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black p-4">
      <div className="mb-8 text-center">
        <h1 className="text-5xl font-black text-yellow-400" style={{ fontFamily: 'Bebas Neue, Impact, sans-serif' }}>STARFUEL</h1>
        <p className="text-gray-500 text-sm">CarFleet &amp; Chauffeur Service</p>
      </div>

      <div className="w-full max-w-md bg-gray-900 rounded-2xl border border-gray-800 p-8 text-center">
        {status === 'verifying' && (
          <>
            <div className="text-4xl mb-4">⏳</div>
            <h2 className="text-xl font-bold text-white mb-2">Verifying your email…</h2>
            <p className="text-gray-400 text-sm">One moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-4xl mb-4">✅</div>
            <h2 className="text-xl font-bold text-white mb-2">Email verified!</h2>
            <p className="text-gray-400 text-sm mb-6">Your Starfuel account is now active. You can sign in.</p>
            <Link to="/login" className="block w-full py-3.5 bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl transition">
              Sign In →
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-4xl mb-4">⚠️</div>
            <h2 className="text-xl font-bold text-white mb-2">Verification failed</h2>
            <p className="text-gray-400 text-sm mb-6">{message}</p>
            <Link to="/login" className="block w-full py-3.5 bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl transition mb-3">
              Go to Sign In
            </Link>
            <p className="text-gray-500 text-xs">
              Need a new link? Contact{' '}
              <a href="mailto:support@starfuelcarfleet.com" className="text-yellow-400 hover:underline">support@starfuelcarfleet.com</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
